let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g5le5")).then(() => parcelRequire('ateGE'));